import React from "react";
import {
  CHANGE_BO_TYPE,
  CHANGE_FREQUENCY,
} from "../../../../actions/create-bot-type";
import BooleanView from "../BooleanView";
import SliderView from "../SliderView";
import TutorialPopup from "../../../help/TutorialPopup";
import { useDispatch, useSelector } from "react-redux";
import { Frequencies, FrequencyValues,FrequencyValuesSimple,FrequenciesSimple,BotType, SUB_TIER, FrequencyValuesPro, FrequenciesPro } from "../../../../Const";
import { checkSub, isMaster, isPro } from "../../../../utils/SubUtils";
import { Form, FormLabel, InputGroup } from "react-bootstrap";
import { formatNumberToString, getFreq, getFreqVal } from "../../../../utils/Utils";
import FundAllocationModule from "../modules/FundAllocationModule";
import OrderTypeModule from "../futures/modules/OrderTypeModule";
import { useEffect } from "react";
import LeftRightForm from "../modules/LeftRightForm";

const InterArbTradeParamsView = (props) => {
  const { newBot ,t,editing} = props;
  const orderType = newBot.baseOrderType;
  const frequency = newBot.frequency;
  const fund = newBot.initFund;
  
  const dispatch = useDispatch();
  const subscription = useSelector(
    (state) => state.auth.user.user_subscription
  );
  const { subPremium, subTier } = checkSub(subscription);
  const FrequenciesProArbitrage = ["5m","15m"];
  const FrequenciesPremiumArbitrage = ["15m"];
  const FrequencyValuesProArbitrage = [5, 15];
  const FrequencyValuesPremiumArbitrage = [15];
  const tradingFreqValues = (isPro(subscription) || isMaster(subscription)) ? FrequencyValuesProArbitrage:FrequencyValuesPremiumArbitrage;
  const tradingFreqencies = (isPro(subscription) || isMaster(subscription)) ? FrequenciesProArbitrage:FrequenciesPremiumArbitrage;
  const frequencyChanged = (val) => {
    if(val){
      dispatch({
        type: CHANGE_FREQUENCY,
        payload: val,
      });
    }
  };
  useEffect(()=>{
    if(!editing)
    {
      dispatch({
        type: CHANGE_FREQUENCY,
        payload: 15,
      });
    }
  },[])
  const formartFrequency = (value) => tradingFreqencies[value];
  return (
    <div>
      <div style={{ marginTop: 20 }}>
       <FundAllocationModule newBot={newBot} t={t} label="max-fund-allocation" editing={editing}></FundAllocationModule>
      </div>
      <LeftRightForm
      right={<FormLabel>{t("arb-fund-msg")}</FormLabel>}
      />
      
      <div style={{ marginTop: 20 }}>
                <OrderTypeModule 
                newBot={newBot} 
                editing={editing} 
                singleOption="market" 
                t={t}></OrderTypeModule>
            </div>
      <div style={{ marginTop: 20 }}>
        <SliderView
          title={t("tf")}
          max={tradingFreqValues.length==1?tradingFreqValues.length:tradingFreqValues.length-1}
          value={tradingFreqValues.indexOf(frequency)}
          formatLabel={formartFrequency}
          onChange={(value) => frequencyChanged(tradingFreqValues[value])}
          tutorial={<TutorialPopup content={t("trading-freq-help")}  />}
        />
      </div>
    </div>
  );
};

export default InterArbTradeParamsView;
